import { ChangeCartPaymentAddressResult } from '../../../graphql/cart/changeCartPaymentAddress';
import { ChangePaymentAddressPayload } from '@spa/lib/store/carts/cartsSlice';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartPaymentAddressRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly paymentAddress: ChangePaymentAddressPayload;
  readonly parentActionId: number;
}
export const apiCartChangeCartPaymentAddressRequestedType =
  'api/cart/changeCartPaymentAddress--requested';
export const apiCartChangeCartPaymentAddressRequested =
  createAction<ApiCartChangeCartPaymentAddressRequestedPayload>(
    apiCartChangeCartPaymentAddressRequestedType
  );
export type ApiCartChangeCartPaymentAddressRequestedAction = ReturnType<
  typeof apiCartChangeCartPaymentAddressRequested
>;

export interface ApiCartChangeCartPaymentAddressSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartPaymentAddressResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartPaymentAddressSucceededType =
  'api/cart/changeCartPaymentAddress--succeeded';
export const apiCartChangeCartPaymentAddressSucceeded =
  createAction<ApiCartChangeCartPaymentAddressSucceededPayload>(
    apiCartChangeCartPaymentAddressSucceededType
  );
export type ApiCartChangeCartPaymentAddressSucceededAction = ReturnType<
  typeof apiCartChangeCartPaymentAddressSucceeded
>;

export interface ApiCartChangeCartPaymentAddressFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartPaymentAddressFailedType =
  'api/cart/changeCartPaymentAddress--failed';
export const apiCartChangeCartPaymentAddressFailed =
  createAction<ApiCartChangeCartPaymentAddressFailedPayload>(
    apiCartChangeCartPaymentAddressFailedType
  );
export type ApiCartChangeCartPaymentAddressFailedAction = ReturnType<
  typeof apiCartChangeCartPaymentAddressFailed
>;
